import React from 'react'
//for navbar
import { Navbar, Nav } from 'react-bootstrap'

//Style (not nav bar)
import './styles/SplashPage.css';

//Content
import { Container, Row, Col } from 'react-bootstrap';

//Page routing
import { Navigate } from 'react-router-dom'
import { onAuthStateChanged } from 'firebase/auth';
import { collection as fsCollection, query as fsQuery, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase/firebase';


export default class SplashPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            authorized: false,
            user: null,
            team: null,
            goToConsole: false,
            goToCreateAccount: false,
        }
        this.unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                this.setState({ team: null, goToConsole: false, signingIn: false });
                return;
            }
            const q = fsQuery(fsCollection(db, 'teamroles'), where('allRoles', 'array-contains', user.uid));
            getDocs(q).then((ref) => {
                const teamDoc = ref.docs[0];
                if (teamDoc) {
                    this.setState({ team: teamDoc.id });
                } else {
                    this.setState({ goToCreateAccount: true });
                }
                this.setState({ signingIn: false });
            });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    }

    componentDidMount() {
        this.setState({signingIn: true,});
    }

    navBar = (props, state) => {
        return (
            <Navbar className="padded-nav-bar" collapseOnSelect bg="primary" variant="dark" expand="lg" fixed="top" >
                <Navbar.Brand href="/">Meet Cruiser</Navbar.Brand>
                <Nav className="mr-auto">
                </Nav>
                {/* <Nav>
                    <Form inline>
                        {state.signingIn ?
                            (
                            <Button variant="primary" disabled>
                                <Spinner
                                  as="span"
                                  animation="grow"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                                Signing In...
                             </Button>)
                        :
                            (this.state.team ?
                                (<Button onClick={() => {
                                    this.setState({
                                        goToConsole: true,
                                    });
                                }} style={{'fontWeight': 'bold'}}>
                                    Go to Console
                                </Button>)
                            :
                                (<Button onClick={() => {
                                    this.setState({
                                        signingIn: true,
                                    });
                                    this.props.signIn();
                                }} style={{'fontWeight': 'bold'}}>
                                    Sign In
                                </Button>)
                            )
                        }
                        {state.team ? <Button onClick={() => this.props.signOut()}>Sign Out</Button> : ""}
                    </Form>
                </Nav> */}
            </Navbar>
        );
    }




    redirect = () => <Navigate to={`/${this.state.team}/console`} replace />;

    sendToCreateAccount = () => <Navigate to="/createaccount" replace />;

    // <Image src="https://firebasestorage.googleapis.com/v0/b/meet-status.appspot.com/o/images%2FpoolBackground.jpg?alt=media&token=a4b19348-3085-4d3c-b1f2-df7e744e8b4d"
    // bsPrefix="backGroundCover" className="backGroundCover"/>

    render() {
        return (
            <>
            {this.navBar(this.props, this.state)}
            <div className="background" >
                <Container fluid={true} className="headingtext">
                    <Row style={{height: '25vh'}} />
                    <Row style={{height: '25vh'}}>
                        <Col>
                            <div className="getStarted">Welcome to</div>
                            <div className="getStarted">Meet Cruiser!</div>
                        </Col>
                    </Row>
                    <Row style={{height: '9.5vh'}}>
                        <Col>
                            <div className="payAsYouGo">Looking for Kedron Hills v. Whitewater?</div>
                            <div className="payAsYouGo"><a className="payAsYouGo" href="/kedhills">Click here!</a></div>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col>
                            <Button variant="outline-primary" className="getStartedButton" onClick={() => {
                                this.setState({signingIn: true,});
                                this.props.signIn();
                            }}>TRY US OUT</Button>
                        </Col>
                    </Row> */}
                </Container>
                {this.state.team && this.state.goToConsole ? this.redirect() : ""}
                {this.state.goToCreateAccount ? this.sendToCreateAccount() : ""}
            </div>
            </>
        );
    }


    renderContent(state, props) {
        return (
            <div>
            </div>
        );
    }

}
